import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  flexGrow,
  flex,
  justifyContent,
  alignItems,
  inlineFlexbox,
  alignSelf
} from '../../../../../styles/helpers/flexbox';

import { widthFillAvailable } from '../../../../../styles/helpers/common';
import { CheckboxContainer, CustomCheckbox } from '../../../../checkbox/styled';

import ThemeHelper from '../../../../../themes/theme-helper';

export const AssignedListWrapper = styled.div`
  ${flexbox()}
  ${flexDirection('column')}
  ${justifyContent('space-between')}
  
  margin: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
`;

export const Header = styled.span((props) => {
  const { typography } = ThemeHelper.getTheme(props);
  return `
    ${alignSelf('flex-start')}

    font-size: ${typography.modalTitle.size};
    margin: 1em 25px 0.5em 25px;
  `;
});

export const Body = styled.div((props) => {
  const { typography } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()}
    ${flexDirection('column')}
    ${flexGrow('1')}
    font-size: ${typography.size};
  `;
});

export const Footer = styled.div`
  ${flexbox()}

  margin-top: 10px;
  width: 100%;

  > div {
    ${flex('1 0 0')}
  }
`;
export const OkButtonContainer = styled.div`
  .button {
    height: 29px;
    width: 86px;
    border-radius: 14.5px;
    font-size: 11px;
    padding: 0;
    margin-left: auto;
  }
`;

export const UnAssignButtonContainer = styled.div`
  .unassign {
    height: 29px;
    width: 86px;
    border-radius: 14.5px;
    font-size: 11px;
    padding: 0;
    margin: 0 auto;
  }
`;

export const NoDataView = styled.div((props) => {
  const { typography, colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()}
    ${flexDirection('column')}

    svg {
      margin-top: 20px;
      width: 50px;
      height: 50px;
      path {
        fill: ${colours.grey[400]};
      }
    }

    p {
      margin: 0 auto;
    }

    p:nth-of-type(2) {
      width: 60%;
      margin-top: 20px;
    }

    width: auto;
    font-family: ${typography.family};
    font-size: 14px;
`;
});

export const AssignedWrapper = styled.div((props) => {
  const { typography } = props.theme;

  return `
    ${flexbox()}
    ${flexDirection('column')}

    width: auto;
    height: 100%;
    font-family: ${typography.family};
    font-size: 14px;
    left: 0;
    background-color: white;
    z-index: 7;
    position: -webkit-sticky;
    position: sticky;
`;
});

export const ListItemContainer = styled.div`
  ${flexbox()};
  ${justifyContent('space-between')};
  ${alignItems('center')};

  box-sizing: border-box;
  background-color: white;
`;

export const HeaderContainer = styled(ListItemContainer)(() => {
  return `
  padding-bottom: 10px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;

  `;
});

export const ActivityHeader = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()};
    ${alignItems('center')};
    ${justifyContent('flex-start')};
    font-weight: 600;
    padding: 0px 8px;
    user-select: none;
    height: 21px;
    width: 60%;

    svg {
      path {
        fill: ${colours.grey[700]};
      }
    }

    .title {
      ${inlineFlexbox()};
      ${alignItems('center')};
      ${justifyContent('flex-start')};
      ${widthFillAvailable()};

      font-weight: 400;
      padding: 5px;
      max-height: 10px;
      cursor: pointer;
      
      svg {
        path {
          fill: ${colours.grey[700]};
        }
      }

      .label {
        margin-left: 10px;
        border-bottom: 2px solid ${colours.grey[200]};
      }
    }

      [class*="svgIconComponent"] {
        width: 10px !important;
        margin-bottom: 4px;
        margin-left: 8px;
      }
    }
  `;
});

export const ActivityTitle = styled.div`
  ${flexbox()};
`;

export const SvgWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    path {
      fill: ${props.status ? colours.grey[1000] : 'black'} !important;
    }
  `;
});

export const CheckboxWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};
    
    ${CheckboxContainer}, ${CustomCheckbox} {
      width: 14px;
      height: 14px;
      border: 1px solid ${colours.grey[200]};
      border-radius: 2px;
    }
    ${CheckboxContainer} {
      width: 16px;
      height: 16px;
    }
`;
});

export const StatusHeader = styled.div((props) => {
  const { colours } = props.theme;

  return `
    width: 25%;

    span{
      border-bottom: 2px solid ${colours.grey[200]};
    }
`;
});

export const ResultsWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${flexDirection('column')}
    ${flexGrow('1')}
    ${widthFillAvailable()}
  
    margin-top: -1px;
    border: 1px solid ${colours.grey[300]};
    border-radius: 15px;
    padding: 25px 10px 10px 20px;
    min-height: 0;
  `;
});



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-assigned/assigned-list/assigned-list.styled.js